// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deeper-view-header{margin-top:20px}.deeper-view-header .exp{border-left:1px solid var(--generalTextColor);margin-left:10px;padding-left:10px}.deeper-view-header h3{font-size:32px;margin-left:15px}.deeper-view-header .MuiAvatar-root{height:55px;width:55px}.deeper-view-header .security-values-wrapper{padding-left:15px}@media screen and (max-width: 1300px){.deeper-view-header h3{font-size:24px}.deeper-view-header .MuiAvatar-root{height:30px;width:30px}}", ""]);
// Exports
module.exports = exports;
